/* Notice slideshow — externalized from sections/notice-slideshow.liquid so the
   browser can cache it and the parser is not blocked (defer on inline scripts
   is ignored). Finds every slideshow instance by id prefix.

   The track is not a scroll container. Slides move with a CSS transform on the
   track (a transition for the glide, none while dragging). Browsers latch a
   wheel/trackpad gesture to the first scroller under the cursor that can take
   the gesture's opening delta, so the previous native horizontal scroller,
   which fills the viewport at the top of the page, swallowed every slightly
   diagonal vertical swipe and the page did not move. Movement now comes only
   from script: dots, arrow keys, autoplay, pointer drag and clearly horizontal
   wheel gestures. */
(function () {
  if (window.__noticeSlideshowLoaded) return;
  window.__noticeSlideshowLoaded = true;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function initSection(outer) {
    if (!outer) return;

    /* Clear previous listeners/timers if re-initializing in the editor */
    if (outer._slideshowCleanup) outer._slideshowCleanup();
    if (outer._slideshowTimer) clearInterval(outer._slideshowTimer);

    var track = outer.querySelector('.notice-slideshow');
    var slides = Array.from(outer.querySelectorAll('.slide-item'));
    var dotItems = Array.from(outer.querySelectorAll('.notice-dots li'));
    if (!track || slides.length < 2) return;

    var current = 0;
    var total = slides.length;
    var timer = null;
    var restartTimer;
    var pageScrollTimer;
    var wheelIdle;
    var visibilityObserver = null;
    var isPointerInside = false;
    var isUserInteracting = false;
    var isPageScrolling = false;
    var isHeroVisible = true;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var cleanup = [];

    function trackWidth() { return track.clientWidth || track.offsetWidth || 1; }

    function listen(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      cleanup.push(function () { target.removeEventListener(eventName, handler, options); });
    }

    /* Put the track at `pos` slides (fractional while dragging). Percent units
       keep resting positions exact through window resizes and rotation. */
    function render(pos, instant) {
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-pos * 100) + '%)';
      if (instant) { void track.offsetWidth; track.style.transition = ''; }
    }

    /* Where the track is right now, in slides, even in the middle of a glide. */
    function currentPos() {
      var t = getComputedStyle(track).transform;
      if (!t || t === 'none') return current;
      try { return -new DOMMatrixReadOnly(t).m41 / trackWidth(); } catch (_) { return current; }
    }

    function setActive(index) {
      current = ((index % total) + total) % total;
      dotItems.forEach(function (li, i) {
        var on = i === current;
        li.classList.toggle('active', on);
        var btn = li.querySelector('button');
        if (btn) { if (on) { btn.setAttribute('aria-current', 'true'); } else { btn.removeAttribute('aria-current'); } }
      });
    }

    function syncVideos(idx, forcePauseAll) {
      slides.forEach(function (slide, i) {
        slide.querySelectorAll('video').forEach(function (v) {
          if (!forcePauseAll && isHeroVisible && i === idx) {
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      });
    }

    function pauseVideos() { syncVideos(current, true); }

    function goTo(index, instant) {
      var idx = ((index % total) + total) % total;
      render(idx, instant);
      setActive(idx);
      syncVideos(idx);
    }

    function shouldAutoplay() {
      var tier = window.NoticeDeviceTier;
      if (tier && tier.isLowEnd) return false;
      return isHeroVisible &&
        !isUserInteracting &&
        !isPointerInside &&
        !isPageScrolling &&
        document.visibilityState !== 'hidden' &&
        !(reduceMotion && reduceMotion.matches);
    }

    function startAutoplay() {
      if (timer || !shouldAutoplay()) return;
      timer = setInterval(function () { goTo(current + 1); }, 5000);
      outer._slideshowTimer = timer;
    }

    function stopAutoplay() { clearInterval(timer); timer = null; outer._slideshowTimer = null; }

    function restartAutoplay(delay) {
      clearTimeout(restartTimer);
      restartTimer = setTimeout(startAutoplay, delay || 250);
    }

    function pauseForUser() {
      isUserInteracting = true;
      stopAutoplay();
      clearTimeout(restartTimer);
    }

    function resumeAfterUser(delay) {
      isUserInteracting = false;
      restartAutoplay(delay || 650);
    }

    dotItems.forEach(function (li, i) {
      listen(li.querySelector('button'), 'click', function () {
        pauseForUser();
        goTo(i);
        resumeAfterUser(900);
      });
    });

    /* Keyboard navigation: ArrowLeft/Right move between slides when focus is
       within the slideshow (e.g. on a dot or a slide CTA). */
    listen(outer, 'keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.keyCode === 37) {
        pauseForUser(); goTo(current - 1); resumeAfterUser(900);
      } else if (e.key === 'ArrowRight' || e.keyCode === 39) {
        pauseForUser(); goTo(current + 1); resumeAfterUser(900);
      } else {
        return;
      }
      e.preventDefault();
    });

    listen(outer, 'mouseenter', function () {
      isPointerInside = true;
      stopAutoplay();
    });
    listen(outer, 'mouseleave', function () {
      isPointerInside = false;
      restartAutoplay();
    });

    /* Pointer drag (touch, pen, primary mouse button). touch-action:pan-y on
       the track leaves vertical pans to the browser; a horizontal pan is
       handled here: the axis is decided after 8px, the track follows the
       pointer, and on release it snaps to the nearest slide. Pans that start
       on a button are left alone so taps and clicks still work. */
    var pan = null;

    function finishPan(e) {
      if (!pan) return;
      if (e && e.pointerId !== pan.id) return;
      var hor = pan.axis === 'x';
      if (hor && track.releasePointerCapture) {
        try { track.releasePointerCapture(pan.id); } catch (_) {}
      }
      track.classList.remove('is-horizontal-panning', 'is-vertical-panning');
      if (hor) goTo(Math.round(pan.pos), true);
      resumeAfterUser(hor ? 1100 : 350);
      pan = null;
    }

    listen(track, 'pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('.slide-btn, .notice-dots button')) return;
      var pos = currentPos();
      render(pos, true); /* freeze a glide in progress under the pointer */
      pan = { id: e.pointerId, startX: e.clientX, startY: e.clientY, startPos: pos, pos: pos, axis: null };
      pauseForUser();
    });

    listen(track, 'pointermove', function (e) {
      if (!pan || e.pointerId !== pan.id) return;
      var dx = e.clientX - pan.startX, dy = e.clientY - pan.startY;
      var ax = Math.abs(dx), ay = Math.abs(dy);
      if (!pan.axis) {
        if (Math.max(ax, ay) < 8) return;
        pan.axis = ax > ay * 1.2 ? 'x' : 'y';
        if (pan.axis === 'x') {
          track.classList.add('is-horizontal-panning');
          if (track.setPointerCapture) {
            try { track.setPointerCapture(pan.id); } catch (_) {}
          }
        } else {
          track.classList.add('is-vertical-panning');
          return;
        }
      }
      if (pan.axis !== 'x') return;
      if (e.cancelable) e.preventDefault();
      pan.pos = clamp(pan.startPos - dx / trackWidth(), 0, total - 1);
      render(pan.pos); /* .is-horizontal-panning disables the transition */
      var idx = Math.round(pan.pos);
      if (idx !== current) { setActive(idx); syncVideos(idx); }
    }, { passive: false });

    listen(track, 'pointerup', finishPan);
    listen(track, 'pointercancel', finishPan);

    /* A mouse drag on an image or link would start native drag-and-drop after
       a few pixels, which cancels the pointer sequence and with it the pan. */
    listen(track, 'dragstart', function (e) { e.preventDefault(); });

    /* Wheel/trackpad over the hero. Vertical and ambiguous gestures are left to
       the browser, which scrolls the page. A clearly horizontal gesture moves
       one slide per gesture and its events are cancelled so the swipe cannot
       turn into browser back/forward navigation. The axis is decided on the
       first event because Chrome only lets the first wheel event of a gesture
       be cancelled. No wrap-around at the ends, like the pointer drag. */
    var wheelAxis = null;

    listen(track, 'wheel', function (e) {
      if (e.ctrlKey) return; /* trackpad pinch-zoom */
      var ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY);
      if (!ax && !ay) return;
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(function () { wheelAxis = null; }, 200);
      var axis = ax > ay * 2 ? 'x' : (ay > ax * 2 ? 'y' : null);
      if (wheelAxis && axis && axis !== wheelAxis) wheelAxis = null; /* direction flipped: new gesture */
      if (!wheelAxis) {
        wheelAxis = axis || 'y';
        if (wheelAxis === 'x') {
          e.preventDefault();
          var next = current + (e.deltaX > 0 ? 1 : -1);
          if (next >= 0 && next < total) {
            pauseForUser();
            goTo(next);
            resumeAfterUser(1100);
          }
        }
        return;
      }
      if (wheelAxis === 'x') e.preventDefault();
    }, { passive: false });

    listen(window, 'scroll', function () {
      isPageScrolling = true;
      stopAutoplay();
      clearTimeout(pageScrollTimer);
      pageScrollTimer = setTimeout(function () {
        isPageScrolling = false;
        restartAutoplay();
      }, 180);
    }, { passive: true });

    listen(document, 'visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        stopAutoplay();
        pauseVideos();
      } else {
        syncVideos(current);
        restartAutoplay();
      }
    });

    if (reduceMotion && reduceMotion.addEventListener) {
      listen(reduceMotion, 'change', function () {
        if (reduceMotion.matches) {
          stopAutoplay();
        } else {
          restartAutoplay();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isHeroVisible = entry.isIntersecting;
          if (isHeroVisible) {
            syncVideos(current);
            restartAutoplay();
          } else {
            stopAutoplay();
            pauseVideos();
          }
        });
      }, { threshold: 0.01 });
      visibilityObserver.observe(outer);
    }

    outer._slideshowCleanup = function () {
      stopAutoplay();
      pauseVideos();
      clearTimeout(restartTimer);
      clearTimeout(pageScrollTimer);
      clearTimeout(wheelIdle);
      track.classList.remove('is-horizontal-panning', 'is-vertical-panning');
      pan = null;
      if (visibilityObserver) visibilityObserver.disconnect();
      cleanup.forEach(function (fn) { fn(); });
      outer._slideshowCleanup = null;
    };

    goTo(0, true);
    startAutoplay();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[id^="notice-slideshow-"]').forEach(initSection);
  }

  /* Script is deferred — DOM is fully parsed by the time it runs */
  initAll();

  /* Re-initialize when theme editor reloads a slideshow section */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      var el = event.target.querySelector('[id^="notice-slideshow-"]');
      if (el) initSection(el);
    }
  });

  /* ── Transparent-to-opaque header flip ─────────────────────────────────────
     Watches the hero slideshow with IntersectionObserver. When the hero's
     bottom edge scrolls past the header group (marquee + header), the header
     gets .notice-home-opaque which triggers the cream+dark CSS rules in
     custom.css. Scoped to the homepage only; no-op on any other template. */
  (function () {
    if (!document.body.classList.contains('current-template-index')) return;

    var headerWrapper = document.querySelector('.header-wrapper');
    var marqueeSection = document.querySelector('.shopify-section-announcement-bar');
    var hero = document.querySelector('[id^="notice-slideshow-"]');
    if (!headerWrapper || !hero) return;

    /* Measure actual announcement bar height and expose as CSS variable */
    var marqueeEl = document.querySelector('.announcement-marquee-wrapper');
    if (marqueeEl) {
      document.documentElement.style.setProperty('--announcement-bar-height', marqueeEl.offsetHeight + 'px');
    }

    var heroObserver = null;

    function initHeroObserver() {
      if (heroObserver) heroObserver.disconnect();

      /* header group height = announcement marquee + sticky header.
         --header-height is set by the header's ResizeObserver; fall back to 62px.
         --announcement-bar-height is set above; fall back to 50px. */
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      var mh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'), 10);
      var offset = (isNaN(hh) ? 62 : hh) + (isNaN(mh) ? 50 : mh);

      heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            headerWrapper.classList.remove('notice-home-opaque');
            if (marqueeSection) marqueeSection.classList.remove('notice-marquee-opaque');
          } else {
            headerWrapper.classList.add('notice-home-opaque');
            if (marqueeSection) marqueeSection.classList.add('notice-marquee-opaque');
          }
        });
      }, { rootMargin: '-' + offset + 'px 0px 0px 0px', threshold: 0 });

      heroObserver.observe(hero);
    }

    initHeroObserver();

    /* Re-measure when the header group changes size (async stylesheets arriving after the first
       measurement, orientation change): keeps --announcement-bar-height and the observer offset in
       sync with the corrected --header-height instead of caching a one-time value. */
    if ('ResizeObserver' in window) {
      var remeasureRaf = 0;
      var remeasure = function () {
        if (remeasureRaf) return;
        remeasureRaf = requestAnimationFrame(function () {
          remeasureRaf = 0;
          var m = document.querySelector('.announcement-marquee-wrapper');
          if (m) document.documentElement.style.setProperty('--announcement-bar-height', m.offsetHeight + 'px');
          initHeroObserver();
        });
      };
      var headerSection = document.querySelector('.section-header');
      var sizeObserver = new ResizeObserver(remeasure);
      if (headerSection) sizeObserver.observe(headerSection);
      if (marqueeEl) sizeObserver.observe(marqueeEl);
    }

    /* Re-init when section reloads in theme editor */
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('[id^="notice-slideshow-"]')) {
        heroObserver && heroObserver.disconnect();
        hero = document.querySelector('[id^="notice-slideshow-"]');
        headerWrapper = document.querySelector('.header-wrapper');
        marqueeSection = document.querySelector('.shopify-section-announcement-bar');
        var marqueeElReload = document.querySelector('.announcement-marquee-wrapper');
        if (marqueeElReload) {
          document.documentElement.style.setProperty('--announcement-bar-height', marqueeElReload.offsetHeight + 'px');
        }
        if (hero && headerWrapper) initHeroObserver();
      }
    });
  })();
})();
